"use client";

import React from "react";

import Grid2 from "@mui/material/Grid2";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { Perks } from "./Perks";
import { PlanCard } from "./PlanCard";
import { useAuthContext } from "../../utils/auth/useAuth";

export function Plans() {
  const { user, userIsLoading, userAdditionalData, userAdditionalDataIsLoading, setShowLogin } = useAuthContext();

  const userIsAdmin = userAdditionalData?.type === "admin";
  const userIsTester = userAdditionalData?.type === "test";

  const loading = userIsLoading || userAdditionalDataIsLoading;

  const errorLoadingCurrentPlan = !loading && !userAdditionalData;
  const currentUserPlanId =
    userAdditionalData?.activeSubscription?.planId ||
    userAdditionalData?.legacySubscription?.planId ||
    userAdditionalData?.subscriptionOverride?.planId ||
    "free";

  // const isLegacySubscription = userAdditionalData?.legacySubscription !== null;
  const isFree = !loading && currentUserPlanId === "free";
  const isDigital = !loading && currentUserPlanId === process.env.NEXT_PUBLIC_DIGITAL_PLAN;
  const isT1 = !loading && currentUserPlanId === process.env.NEXT_PUBLIC_T1_PLAN;
  const isDigitalPlusPress = !loading && currentUserPlanId === process.env.NEXT_PUBLIC_DIGITAL_AND_PRESS_PLAN;
  const hasPlan = !isFree;

  if (typeof process.env.NEXT_PUBLIC_DIGITAL_PLAN !== "string") {
    throw new Error("Missing NEXT_PUBLIC_DIGITAL_PLAN value");
  }

  if (typeof process.env.NEXT_PUBLIC_DIGITAL_AND_PRESS_PLAN !== "string") {
    throw new Error("Missing NEXT_PUBLIC_DIGITAL_AND_PRESS_PLAN value");
  }

  if (typeof process.env.NEXT_PUBLIC_T1_PLAN !== "string") {
    throw new Error("Missing NEXT_PUBLIC_T1_PLAN value");
  }

  return (
    <>
      <Grid2 container spacing={2} mb={4} justifyContent="center">
        <Grid2 size={{ xs: 12, sm: 7, md: 4 }}>
          <PlanCard
            free
            name="Gratuito"
            perks={<Perks items={["Acesso online aos artigos livres"]} />}
            planId="free"
            current={isFree}
          />
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 7, md: 4 }}>
          <PlanCard
            loading={loading}
            name="Digital"
            price="R$ 19,90"
            perks={<Perks items={["Acesso online aos artigos livres", <>Acesso online aos artigos restritos 🔒</>]} />}
            current={isDigital}
            userEmail={user?.email}
            planId={process.env.NEXT_PUBLIC_DIGITAL_PLAN}
            hasPlan={hasPlan}
          />
        </Grid2>

        {(userIsAdmin || userIsTester) && (
          <Grid2 size={{ xs: 12, sm: 7, md: 4 }}>
            <PlanCard
              loading={loading}
              name="Teste 1"
              price="R$ 0,10"
              perks={
                <Perks items={["Acesso online aos artigos livres", <>Acesso online aos artigos restritos 🔒</>]} />
              }
              current={isT1}
              userEmail={user?.email}
              planId={process.env.NEXT_PUBLIC_T1_PLAN}
              hasPlan={hasPlan}
            />
          </Grid2>
        )}
      </Grid2>

      {(() => {
        if (loading) {
          return <Typography textAlign="center">Carregando seu plano atual</Typography>;
        }

        if (!user) {
          return (
            <Typography textAlign="center">
              <Link
                href="#"
                onClick={() => {
                  setShowLogin(true);
                }}
              >
                Acesse sua conta
              </Link>{" "}
              para ver seu plano atual ou assinar outro plano
            </Typography>
          );
        }

        if (errorLoadingCurrentPlan) {
          return <Typography textAlign="center">Não foi possível carregar seu plano atual</Typography>;
        }
      })()}
    </>
  );
}
